import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Award, Target, Users, TrendingUp } from 'lucide-react';

const About = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-gray-900 to-gray-800 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Sobre GUDO Real Estate
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Más de 15 años transformando sueños en patrimonio
          </p>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <Card className="border-0 shadow-xl hover:shadow-2xl transition-shadow">
              <CardContent className="p-8">
                <div className="w-16 h-16 bg-golden-100 rounded-2xl flex items-center justify-center mb-6">
                  <Target className="w-8 h-8 text-golden-600" />
                </div>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Nuestra Misión</h2>
                <p className="text-gray-600 leading-relaxed text-lg">
                  Facilitar el acceso a propiedades de calidad superior, brindando asesoría personalizada y soluciones integrales que superen las expectativas de nuestros clientes, construyendo relaciones de confianza a largo plazo.
                </p>
              </CardContent>
            </Card>

            <Card className="border-0 shadow-xl hover:shadow-2xl transition-shadow">
              <CardContent className="p-8">
                <div className="w-16 h-16 bg-golden-100 rounded-2xl flex items-center justify-center mb-6">
                  <TrendingUp className="w-8 h-8 text-golden-600" />
                </div>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">Nuestra Visión</h2>
                <p className="text-gray-600 leading-relaxed text-lg">
                  Ser la empresa líder en bienes raíces en México, reconocida por nuestra excelencia, innovación y compromiso con el desarrollo de comunidades prósperas y sostenibles.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-gray-900 mb-8 text-center">Nuestra Historia</h2>
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 leading-relaxed mb-6">
              Fundada en 2010, GUDO Real Estate nació con una visión clara: democratizar el acceso a propiedades de alta calidad en México. Lo que comenzó como un pequeño equipo de apasionados por los bienes raíces se ha convertido en una de las empresas más confiables del sector.
            </p>
            <p className="text-gray-600 leading-relaxed mb-6">
              A lo largo de estos 15 años, hemos ayudado a más de 500 familias y empresarios a encontrar su propiedad ideal, desde acogedoras casas residenciales hasta hoteles boutique y desarrollos comerciales. Nuestro compromiso con la excelencia y la transparencia nos ha ganado la confianza de miles de clientes.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Hoy, continuamos expandiendo nuestro portafolio con propiedades cuidadosamente seleccionadas en las mejores ubicaciones de México, siempre con el objetivo de ofrecer las mejores oportunidades de inversión y calidad de vida.
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center">Nuestros Valores</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-golden-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <Award className="w-10 h-10 text-golden-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Excelencia</h3>
              <p className="text-gray-600">
                Buscamos la máxima calidad en cada propiedad y servicio que ofrecemos
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-golden-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <Users className="w-10 h-10 text-golden-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Confianza</h3>
              <p className="text-gray-600">
                Construimos relaciones duraderas basadas en honestidad y transparencia
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-golden-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <Target className="w-10 h-10 text-golden-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Compromiso</h3>
              <p className="text-gray-600">
                Dedicados a superar las expectativas de nuestros clientes
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-golden-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <TrendingUp className="w-10 h-10 text-golden-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Innovación</h3>
              <p className="text-gray-600">
                Utilizamos tecnología y métodos modernos para mejor servicio
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-20 bg-gradient-to-br from-golden-600 to-golden-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-5xl md:text-6xl font-bold text-white mb-2">15+</div>
              <div className="text-golden-50">Años de Experiencia</div>
            </div>
            <div className="text-center">
              <div className="text-5xl md:text-6xl font-bold text-white mb-2">500+</div>
              <div className="text-golden-50">Propiedades Vendidas</div>
            </div>
            <div className="text-center">
              <div className="text-5xl md:text-6xl font-bold text-white mb-2">98%</div>
              <div className="text-golden-50">Satisfacción</div>
            </div>
            <div className="text-center">
              <div className="text-5xl md:text-6xl font-bold text-white mb-2">24/7</div>
              <div className="text-golden-50">Soporte</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
